import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCookieConsentContext } from './CookieConsentProvider';
import { trackPageView } from './analyticsUtils';

const RouteChangeTracker = () => {
  const location = useLocation();
  const { consentState } = useCookieConsentContext();

  useEffect(() => {
    // Scroll to top when route changes
    window.scrollTo(0, 0);
    
    if (!consentState.analytics) return;
    
    // Aspetta che il titolo della pagina sia aggiornato
    setTimeout(() => {
      const pathWithQuery = `${location.pathname}${location.search}`;
      console.log('RouteChangeTracker: Tracking page view for:', pathWithQuery);
      console.log('Current page title:', document.title);
      trackPageView(pathWithQuery);
    }, 100);
  }, [location.pathname, location.search, consentState.analytics]);

  return null;
};

export default RouteChangeTracker;

